import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createVNode as _createVNode, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../assets/images/Logo.png'
import _imports_1 from '../../assets/images/a_b.png'
import _imports_2 from '../../assets/03.mp4'
import _imports_3 from '../../assets/10.png'
import _imports_4 from '../../assets/images/a_r.png'


const _withScopeId = n => (_pushScopeId("data-v-7c2920a2"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "home",
  id: "login"
}
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "navbar" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "navbar_logo" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: ""
  })
], -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_1,
    alt: ""
  })
], -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "banner" }, [
  /*#__PURE__*/_createElementVNode("video", {
    src: _imports_2,
    autoplay: "true",
    loop: "true",
    muted: "true",
    style: {"width":"100%","height":"100%","object-fit":"fill"},
    width: "100%",
    class: "video"
  }),
  /*#__PURE__*/_createElementVNode("img", {
    class: "cover",
    src: _imports_3,
    alt: ""
  })
], -1))
const _hoisted_7 = {
  id: "about",
  class: "aboutInt"
}
const _hoisted_8 = { class: "aboutInt_left" }
const _hoisted_9 = { class: "aboutInt_left_header wow animated" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "trans" }, "ABOUT PUSI STANDARD", -1))
const _hoisted_11 = { class: "h1" }
const _hoisted_12 = { class: "des" }
const _hoisted_13 = { class: "content" }
const _hoisted_14 = { class: "aboutInt_right wow animated" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  id: "aboutInt_bottom",
  style: {"position":"absolute","bottom":"25%"}
}, null, -1))
const _hoisted_16 = {
  id: "business",
  class: "business"
}
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "business_header base_header" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "trans" }, "BUSINESS INTRODUCTION"),
  /*#__PURE__*/_createElementVNode("p", { class: "h1" }, "业务介绍")
], -1))
const _hoisted_18 = { class: "business_container" }
const _hoisted_19 = { class: "container" }
const _hoisted_20 = { class: "box" }
const _hoisted_21 = { class: "cover" }
const _hoisted_22 = ["src"]
const _hoisted_23 = { class: "title" }
const _hoisted_24 = { class: "content" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "line" }, null, -1))
const _hoisted_26 = {
  id: "news",
  class: "news"
}
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "news_header base_header" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "trans" }, "PUSI STANDARD NEWS"),
  /*#__PURE__*/_createElementVNode("p", { class: "h1" }, "普思新闻")
], -1))
const _hoisted_28 = { class: "news_container" }
const _hoisted_29 = { class: "container" }
const _hoisted_30 = { class: "box" }
const _hoisted_31 = { class: "cover" }
const _hoisted_32 = ["src"]
const _hoisted_33 = { class: "text" }
const _hoisted_34 = { class: "time" }
const _hoisted_35 = { class: "day" }
const _hoisted_36 = { class: "title" }
const _hoisted_37 = { class: "content" }
const _hoisted_38 = { class: "right" }
const _hoisted_39 = ["onClick"]
const _hoisted_40 = { class: "box" }
const _hoisted_41 = { class: "time" }
const _hoisted_42 = { class: "day" }
const _hoisted_43 = { class: "ym" }
const _hoisted_44 = { class: "text" }
const _hoisted_45 = { class: "title" }
const _hoisted_46 = { class: "content" }
const _hoisted_47 = { class: "btnGroup seeMore" }
const _hoisted_48 = {
  id: "industryDynamics",
  class: "industryDynamics"
}
const _hoisted_49 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "industryDynamics_header base_header" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "trans" }, "INDUSTRY DYNAMICS"),
  /*#__PURE__*/_createElementVNode("p", { class: "h1" }, "行业动态")
], -1))
const _hoisted_50 = { class: "industryDynamics_container" }
const _hoisted_51 = { class: "container" }
const _hoisted_52 = ["onClick"]
const _hoisted_53 = { class: "time" }
const _hoisted_54 = { class: "day" }
const _hoisted_55 = { class: "ym" }
const _hoisted_56 = { class: "title" }
const _hoisted_57 = { class: "btnGroup seeMore" }
const _hoisted_58 = {
  id: "partyBuildingActivities",
  class: "partyBuildingActivities"
}
const _hoisted_59 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "partyBuildingActivities_header base_header" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "trans" }, "PARTY BUILDING ACTIVITIES"),
  /*#__PURE__*/_createElementVNode("p", { class: "h1" }, "党建活动")
], -1))
const _hoisted_60 = { class: "partyBuildingActivities_container" }
const _hoisted_61 = { class: "container" }
const _hoisted_62 = ["src"]
const _hoisted_63 = { class: "box" }
const _hoisted_64 = { class: "time" }
const _hoisted_65 = { class: "day" }
const _hoisted_66 = { class: "ym" }
const _hoisted_67 = { class: "arrow" }
const _hoisted_68 = ["onClick"]
const _hoisted_69 = { class: "title" }
const _hoisted_70 = { class: "btnGroup seeMore" }
const _hoisted_71 = {
  id: "digitalManagmentPlatform",
  class: "digitalManagmentPlatform"
}
const _hoisted_72 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "digitalManagmentPlatform_header base_header" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "trans" }, "DIGITAL MANAGEMENT PLATFORM"),
  /*#__PURE__*/_createElementVNode("p", { class: "h1" }, "数字化管理平台")
], -1))
const _hoisted_73 = { class: "digitalManagmentPlatform_container" }
const _hoisted_74 = { class: "container" }
const _hoisted_75 = ["src"]
const _hoisted_76 = { class: "box" }
const _hoisted_77 = { class: "title" }
const _hoisted_78 = { class: "content" }
const _hoisted_79 = ["onClick"]
const _hoisted_80 = /*#__PURE__*/_createStaticVNode("<div class=\"layout-1 other\" data-v-7c2920a2><div class=\"other-bottom\" data-v-7c2920a2><div class=\"box\" data-v-7c2920a2><div class=\"other-bottom-box\" data-v-7c2920a2><p class=\"title\" data-v-7c2920a2>合规举报渠道</p><p class=\"text\" data-v-7c2920a2>合规电话</p><p class=\"text\" data-v-7c2920a2>0553-7526147</p><p class=\"text\" data-v-7c2920a2>合规邮箱</p><p class=\"text\" data-v-7c2920a2>hegui@mychery.com</p></div><div class=\"other-bottom-box\" data-v-7c2920a2><p class=\"title\" data-v-7c2920a2>普思数字化管理平台</p><p class=\"text\" data-v-7c2920a2>产品认证管理系统</p><p class=\"text\" data-v-7c2920a2>标准法规库</p><p class=\"text\" data-v-7c2920a2>数字化道路实验室</p><p class=\"text\" data-v-7c2920a2>业财一体化平台</p><p class=\"text\" data-v-7c2920a2>数据集成系统</p></div><div class=\"other-bottom-box\" data-v-7c2920a2><p class=\"title\" data-v-7c2920a2>联系我们</p><p class=\"text my-box\" data-v-7c2920a2> 公司地址：中国(安徽)自由贸易试验区芜湖片区银湖北路38号留学生楼D501室 </p><p class=\"text my-box\" data-v-7c2920a2>公司电话：0553-5636736 工作日09:00-18:00</p><p class=\"text my-box\" data-v-7c2920a2>邮编：241006</p><p class=\"text\" data-v-7c2920a2> </p></div></div></div><div class=\"footer\" data-v-7c2920a2><div data-v-7c2920a2>©2024 普思标准所有</div></div></div>", 1)

import { defineComponent, ref, reactive, onMounted } from "vue";
import {
  companyArticlesApi,
  partyArticlesApi,
  industryArticlesApi,
  businessIntroductionsApi,
  digitalManagementsApi,
  aboutsApi,
  menusApi
} from "../../api/content";
import router from "@/router";
import moment from 'moment';
import marked from 'marked';
import { ElBacktop } from "element-plus";


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

defineComponent({ name: "HomePage" });

const activeIndex = ref("1");

const handleSelect = (key: string, keyPath: string[]) => {
  const obj = routerData.value.find(
    (item: any) =>
      Number(item.id) ===
      (keyPath.length === 1 ? Number(key) : Number(keyPath[0])),
  );
  if (obj) {
    activeIndex.value = String(obj.id);
    // 跳锚链接 其他自行处理
    document.querySelector(obj.path)?.scrollIntoView({
      behavior: "smooth",
      block: "start",
      inline: "nearest",
    });
  }
};

const handleClick = (item: any) => {
  if(item.type === 'cms'){
    handleListClick(item.cmsinfoid,item.cmsinfoname)
  }else if(item.type === 'system'){
    window.open(item.path, "_blank");
  }else{
    activeIndex.value = String(item.id);
    if (item.path) {
      // 跳锚链接 其他自行处理
      document.querySelector(item.path)?.scrollIntoView({
        behavior: "smooth",
        block: "start",
        inline: "nearest",
      });
    }
  }
};

const bannerList = ref([
  {
    id: 1,
    img: require("../../assets/images/banner.png"),
    video: require("../../assets/03.mp4"),
    type: "video",
  },
  {
    id: 2,
    img: require("../../assets/images/banner.png"),
    video: require("../../assets/03.mp4"),
    type: "img",
  },
  {
    id: 3,
    img: require("../../assets/images/banner.png"),
    video: require("../../assets/03.mp4"),
    type: "img",
  },
]);

// 初始化数据
// 菜单
const routerData = ref("")
// 关于普思
const about = reactive({
  title: "",
  tips: "",
  content: "",
  type: [
    { id: 1, title: "开拓创新" },
    { id: 2, title: "专业高效" },
    { id: 3, title: "顾客满意" },
    { id: 4, title: "合作共赢" },
  ],
});
// 业务介绍
const businessList = ref("")
// 普思新闻-getCompanyArticlesList
const newsList = ref("")
// 普思新闻-左-getCompanyArticlesLeft
const newsLeft = reactive({
        id: '',
        title: '',
        content: '',
        cover: '',
        createdAt: {
          date: '',
          day: '',
          month: '',
          year: '',
        },
      })
// 行业动态-getIndustryArticlesList
const industryDynamicsList = ref("")
// 党建活动-getPartyArticlesList
const partyBuildingActivitesList = ref("")
// 数字化管理平台
const digitalManagmentPlatformList = ref("")

// 获取数据
function getMenu() {
  menusApi().then((res) => {
    routerData.value = res.data.data.attributes.map;
  });
}

function getAbout() {
  aboutsApi().then((res) => {
    about.title = res.data.data.attributes.title
    about.content = res.data.data.attributes.content
    about.tips = res.data.data.attributes.tips
  });
}

function getBusinessIntroductions() {
  businessIntroductionsApi().then((res) => {
    const formattedData = res.data.data.map((item: any) => {
      const coverUrl =
        item.attributes.cover.data == null
          ? ""
          : "https://pusi.mychery.com:5443" +
            item.attributes.cover.data.attributes.url;
      const title = item.attributes.title;
      const text = item.attributes.content;
      const id = item.id;
      const cmsinfoid = item.attributes.cmsinfoid
      const cmsinfoname = item.attributes.cmsinfoname

      return {
        id: id,
        title: title,
        content: text,
        img: coverUrl,
        cmsinfoid: cmsinfoid,
        cmsinfoname: cmsinfoname
      }
    });
    businessList.value = formattedData;
  });
}

function getCompanyArticlesList() {
  companyArticlesApi().then((res) => {
    const formattedData = res.data.data.map((item: any) => {
      const coverUrl =
        item.attributes.cover.data == null
          ? ""
          : "https://pusi.mychery.com:5443" +
            item.attributes.cover.data.attributes.url;
      const title = item.attributes.title;
      const text = item.attributes.content;
      const id = item.id;
      const date = moment(item.attributes.createdAt).format("YYYY-MM-DD")
      const day = moment(item.attributes.createdAt).format("DD")
      const month = moment(item.attributes.createdAt).format("MM")
      const year = moment(item.attributes.createdAt).format("YYYY")

      return {
        id: id,
        title: title,
        content: text,
        cover: coverUrl,
        createdAt: {
          date: date,
          day: day,
          month: month,
          year: year,
        },
      }
    });
    newsList.value = formattedData;
  });
}

function getCompanyArticlesLeft() {
  companyArticlesApi().then((res) => {
    const coverUrl =
    res.data.data[0].attributes.cover.data == null
        ? ""
        : "https://pusi.mychery.com:5443" +
        res.data.data[0].attributes.cover.data.attributes.url;
    const title = res.data.data[0].attributes.title;
    const text = res.data.data[0].attributes.content;
    const id = res.data.data[0].id;
    const date = moment(res.data.data[0].attributes.createdAt).format("YYYY-MM-DD")
    const day = moment(res.data.data[0].attributes.createdAt).format("DD")
    const month = moment(res.data.data[0].attributes.createdAt).format("MM")
    const year = moment(res.data.data[0].attributes.createdAt).format("YYYY")
    newsLeft.id = id
    newsLeft.title = title
    newsLeft.content = text
    newsLeft.cover = coverUrl
    newsLeft.createdAt = {
          date: date,
          day: day,
          month: month,
          year: year,
        }
  });
}

function getIndustryArticlesList() {
  industryArticlesApi().then((res) => {
    const formattedData = res.data.data.map((item: any) => {
      const coverUrl =
        item.attributes.cover.data == null
          ? ""
          : "https://pusi.mychery.com:5443" +
            item.attributes.cover.data.attributes.url;
      const text = item.attributes.title;
      const date = moment(item.attributes.createdAt).format("YYYY-MM-DD")
      const day = moment(item.attributes.createdAt).format("DD")
      const month = moment(item.attributes.createdAt).format("MM")
      const year = moment(item.attributes.createdAt).format("YYYY")
      const id = item.id;

      return {
        id: id,
        title: text,
        createdAt: {
          date: date,
          day: day,
          month: month,
          year: year,
        }
      }
    });
    industryDynamicsList.value = formattedData;
  });
}

function getPartyArticlesList() {
  partyArticlesApi().then((res) => {
    const formattedData = res.data.data.map((item: any) => {
      console.log(item.attributes.cover.data);
      const coverUrl =
        item.attributes.cover.data == null
          ? ""
          : "https://pusi.mychery.com:5443" +
            item.attributes.cover.data.attributes.url;

      const title = item.attributes.title;
      const text = item.attributes.content;
      const id = item.id;
      const date = moment(item.attributes.createdAt).format("YYYY-MM-DD")
      const day = moment(item.attributes.createdAt).format("DD")
      const month = moment(item.attributes.createdAt).format("MM")
      const year = moment(item.attributes.createdAt).format("YYYY")

      return {
        id: id,
        title: title,
        cover: coverUrl,
        createdAt: {
          date: date,
          day: day,
          month: month,
          year: year,
        },
      }
    });
    partyBuildingActivitesList.value = formattedData;
  });
}

function getDigitalManagmentList() {
  digitalManagementsApi().then((res) => {
    const formattedData = res.data.data.map((item: any) => {
      const coverUrl =
        item.attributes.cover.data == null
          ? ""
          : "https://pusi.mychery.com:5443" +
            item.attributes.cover.data.attributes.url;
      const title = item.attributes.title;
      const text = item.attributes.content;
      const id = item.id;
      const jumpAddress = item.attributes.jumpAddress

      return {
        id: id,
        title: title,
        content: text,
        img: coverUrl,
        jumpAddress: jumpAddress
      }
    });
    digitalManagmentPlatformList.value = formattedData;
  });
}

const businessCurrent = ref(1);
const businessToggle = (id: number) => (businessCurrent.value = id);

//跳转
// 公司动态列表
function toCompanyList() {
  let routeData = router.resolve({
    path: "/list",
    query: {
      category: "company",
    },
  });
  window.open(routeData.href, "_blank");
}
// 行业动态
function toIndustryList() {
  let routeData = router.resolve({
    path: "/list",
    query: {
      category: "industry",
    },
  });
  window.open(routeData.href, "_blank");
}
// 党建活动
function toPartyList() {
  let routeData = router.resolve({
    path: "/list",
    query: {
      category: "party",
    },
  });
  window.open(routeData.href, "_blank");
}

// 调用方法
getMenu()
getAbout()
getBusinessIntroductions();
getCompanyArticlesList();
getCompanyArticlesLeft();
getIndustryArticlesList();
getPartyArticlesList();
getDigitalManagmentList();

function handleListClick(id: any,category: any) {
  let routeData = router.resolve({
    path: "/content",
    query: {
      id: id,
      category: category,
    },
  });
  console.log('routeData=====',routeData)
  if(routeData.query.id != null){
    window.open(routeData.href, "_blank");
  }
}


function handleTitleClick(item: any){
  console.log(`标题 ${item.title} 被点击了！`);
  debugger
  // 获取所有带有 .el-sub-menu 类的 DOM 元素
  var menuItems = document.querySelectorAll('.navbar .el-sub-menu');
  
  // 将 NodeList 转换为数组
  const menuItemsArray = Array.from(menuItems);
  console.log('===',menuItemsArray)

  // 假设 item.id 与顶部菜单的 id 对应，使用 find 方法查找对应的菜单项
  menuItems.forEach(function(menuItem) {
      var spanText = menuItem.querySelector('span').textContent.trim();
      // 判断是否包含 "登录" 字符
      console.log("====",spanText)
      if (spanText === "登录") {
        activeIndex.value = '8'
        var mouseOverEvent = new Event('mouseover');
        var mouseEnterEvent = new Event('mouseenter');

        // 触发该菜单项的 hover 效果
        menuItem.dispatchEvent(mouseOverEvent);
        menuItem.dispatchEvent(mouseEnterEvent);

        document.querySelector("#login")?.scrollIntoView({
          behavior: "smooth",
          block: "start",
          inline: "nearest",
        });
      }
  })
}

const wow = new WOW({
  boxClass: "wow",
  animateClass: "animated",
  offset: 0,
  mobile: true,
  live: true,
});
wow.init();
onMounted(() => {
  const aboutBottom = document.querySelector("#aboutInt_bottom");
  const aboutLeft = document.querySelector(
    ".aboutInt_left .aboutInt_left_header",
  );
  const aboutRight = document.querySelector(".aboutInt_right");
  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        console.log(entry.isIntersecting);
        if (entry.isIntersecting) {
          aboutLeft && aboutLeft.classList.add("animate__fadeInUp");
          aboutRight && aboutRight.classList.add("animate__fadeInUp");
          observer.unobserve(entry.target);
        }
      });
    },
    {
      threshold: 0.1, // Adjust this value as needed
    },
  );
  if (aboutBottom) {
    observer.observe(aboutBottom);
  }
});

return (_ctx: any,_cache: any) => {
  const _component_el_menu_item = _resolveComponent("el-menu-item")!
  const _component_el_sub_menu = _resolveComponent("el-sub-menu")!
  const _component_el_menu = _resolveComponent("el-menu")!
  const _component_ArrowRight = _resolveComponent("ArrowRight")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_carousel_item = _resolveComponent("el-carousel-item")!
  const _component_el_carousel = _resolveComponent("el-carousel")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createVNode(_component_el_menu, {
          ellipsis: "",
          "default-active": activeIndex.value,
          class: "navbar_list",
          mode: "horizontal",
          onSelect: handleSelect,
          "background-color": "rgba(0, 140, 214, 1)",
          "text-color": "rgba(235, 235, 235, 1)",
          "active-text-color": "rgba(235, 235, 235, 1)"
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(routerData.value, (item) => {
              return (_openBlock(), _createElementBlock(_Fragment, {
                key: item.id
              }, [
                (item.children.length === 0)
                  ? (_openBlock(), _createBlock(_component_el_menu_item, {
                      key: 0,
                      index: String(item.id)
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(item.title), 1)
                      ]),
                      _: 2
                    }, 1032, ["index"]))
                  : (item.children.length > 0)
                    ? (_openBlock(), _createBlock(_component_el_sub_menu, {
                        key: 1,
                        index: String(item.id),
                        "popper-class": "navbar_popper navbar_popper_list",
                        onClick: ($event: any) => (handleClick(item)),
                        class: _normalizeClass({ 'is-active': activeIndex.value === String(item.id) })
                      }, {
                        title: _withCtx(() => [
                          _createElementVNode("span", null, _toDisplayString(item.title), 1),
                          _hoisted_5
                        ]),
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.children, (child) => {
                            return (_openBlock(), _createElementBlock(_Fragment, {
                              key: child.id
                            }, [
                              (child.children.length === 0)
                                ? (_openBlock(), _createBlock(_component_el_menu_item, {
                                    key: 0,
                                    index: String(child.pid) + '-' + String(child.id),
                                    onClick: ($event: any) => (handleClick(child))
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(child.title), 1)
                                    ]),
                                    _: 2
                                  }, 1032, ["index", "onClick"]))
                                : (child.children.length > 0)
                                  ? (_openBlock(), _createBlock(_component_el_sub_menu, {
                                      key: 1,
                                      index: String(child.pid) + '-' + String(child.id)
                                    }, {
                                      title: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(child.title), 1)
                                      ]),
                                      default: _withCtx(() => [
                                        (child.children)
                                          ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(child.children, (sub) => {
                                              return (_openBlock(), _createBlock(_component_el_menu_item, {
                                                key: sub.id,
                                                index: String(sub.pid) + '-' + String(sub.id),
                                                onClick: ($event: any) => (handleClick(sub))
                                              }, {
                                                default: _withCtx(() => [
                                                  _createTextVNode(_toDisplayString(sub.title), 1)
                                                ]),
                                                _: 2
                                              }, 1032, ["index", "onClick"]))
                                            }), 128))
                                          : (_ctx.sub.children.length > 0)
                                            ? (_openBlock(), _createBlock(_component_el_sub_menu, {
                                                key: 1,
                                                index: String(_ctx.sub.pid) + '-' + String(_ctx.sub.id)
                                              }, {
                                                title: _withCtx(() => [
                                                  _createTextVNode(_toDisplayString(_ctx.sub.title), 1)
                                                ]),
                                                default: _withCtx(() => [
                                                  (_ctx.sub.children)
                                                    ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.sub.children, (subs) => {
                                                        return (_openBlock(), _createBlock(_component_el_menu_item, {
                                                          key: subs.id,
                                                          index: String(subs.pid) + '-' + String(subs.id)
                                                        }, {
                                                          default: _withCtx(() => [
                                                            _createTextVNode(_toDisplayString(subs.title), 1)
                                                          ]),
                                                          _: 2
                                                        }, 1032, ["index"]))
                                                      }), 128))
                                                    : _createCommentVNode("", true)
                                                ]),
                                                _: 1
                                              }, 8, ["index"]))
                                            : _createCommentVNode("", true)
                                      ]),
                                      _: 2
                                    }, 1032, ["index"]))
                                  : _createCommentVNode("", true)
                            ], 64))
                          }), 128))
                        ]),
                        _: 2
                      }, 1032, ["index", "onClick", "class"]))
                    : _createCommentVNode("", true)
              ], 64))
            }), 128))
          ]),
          _: 1
        }, 8, ["default-active"])
      ])
    ]),
    _hoisted_6,
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("div", _hoisted_9, [
          _hoisted_10,
          _createElementVNode("p", _hoisted_11, _toDisplayString(about.title), 1),
          _createElementVNode("p", _hoisted_12, _toDisplayString(about.tips), 1),
          _createElementVNode("p", _hoisted_13, _toDisplayString(about.content), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_14, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(about.type, (item) => {
          return (_openBlock(), _createElementBlock("p", {
            class: "",
            key: item.id
          }, _toDisplayString(item.title), 1))
        }), 128))
      ]),
      _hoisted_15
    ]),
    _createElementVNode("div", _hoisted_16, [
      _hoisted_17,
      _createElementVNode("div", _hoisted_18, [
        _createElementVNode("div", _hoisted_19, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(businessList.value, (item) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "item",
              key: item.id
            }, [
              _createElementVNode("div", _hoisted_20, [
                _createElementVNode("div", _hoisted_21, [
                  _createElementVNode("img", {
                    src: item.img,
                    alt: ""
                  }, null, 8, _hoisted_22)
                ]),
                _createElementVNode("p", _hoisted_23, _toDisplayString(item.title), 1),
                _createElementVNode("p", _hoisted_24, _toDisplayString(item.content), 1),
                _hoisted_25
              ])
            ]))
          }), 128))
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_26, [
      _hoisted_27,
      _createElementVNode("div", _hoisted_28, [
        _createElementVNode("div", _hoisted_29, [
          _createElementVNode("div", {
            class: "left",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (handleListClick(newsLeft.id,'company')))
          }, [
            _createElementVNode("div", _hoisted_30, [
              _createElementVNode("div", _hoisted_31, [
                _createElementVNode("img", {
                  src: newsLeft.cover,
                  alt: ""
                }, null, 8, _hoisted_32)
              ]),
              _createElementVNode("div", _hoisted_33, [
                _createElementVNode("p", _hoisted_34, [
                  _createElementVNode("span", _hoisted_35, _toDisplayString(newsLeft.createdAt.day), 1),
                  _createTextVNode(" /" + _toDisplayString(newsLeft.createdAt.year) + "-" + _toDisplayString(newsLeft.createdAt.month), 1)
                ]),
                _createElementVNode("p", _hoisted_36, _toDisplayString(newsLeft.title), 1),
                _createElementVNode("p", _hoisted_37, _toDisplayString(newsLeft.content.replace(/<\/?[^>]+(>|$)/g, "")), 1)
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_38, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(newsList.value, (item) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "item",
                key: item.id,
                onClick: ($event: any) => (handleListClick(item.id,'company'))
              }, [
                _createElementVNode("div", _hoisted_40, [
                  _createElementVNode("div", _hoisted_41, [
                    _createElementVNode("p", _hoisted_42, _toDisplayString(item.createdAt.day), 1),
                    _createElementVNode("p", _hoisted_43, _toDisplayString(newsLeft.createdAt.year) + "-" + _toDisplayString(item.createdAt.month), 1)
                  ]),
                  _createElementVNode("div", _hoisted_44, [
                    _createElementVNode("p", _hoisted_45, _toDisplayString(item.title), 1),
                    _createElementVNode("p", _hoisted_46, _toDisplayString(item.content.replace(/<\/?[^>]+(>|$)/g, "")), 1)
                  ])
                ])
              ], 8, _hoisted_39))
            }), 128))
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_47, [
        _createVNode(_component_el_button, {
          type: "info",
          round: "",
          onClick: toCompanyList
        }, {
          default: _withCtx(() => [
            _createTextVNode(" 查看更多"),
            _createVNode(_component_el_icon, null, {
              default: _withCtx(() => [
                _createVNode(_component_ArrowRight)
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ])
    ]),
    _createElementVNode("div", _hoisted_48, [
      _hoisted_49,
      _createElementVNode("div", _hoisted_50, [
        _createElementVNode("div", _hoisted_51, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(industryDynamicsList.value, (item) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "item animated animate__fadeInRight",
              onClick: ($event: any) => (handleListClick(item.id,'industry')),
              key: item.id
            }, [
              _createElementVNode("div", _hoisted_53, [
                _createElementVNode("p", _hoisted_54, _toDisplayString(item.createdAt.day), 1),
                _createElementVNode("p", _hoisted_55, _toDisplayString(item.createdAt.year) + "/" + _toDisplayString(item.createdAt.month), 1)
              ]),
              _createElementVNode("p", _hoisted_56, _toDisplayString(item.title), 1)
            ], 8, _hoisted_52))
          }), 128))
        ])
      ]),
      _createElementVNode("div", _hoisted_57, [
        _createVNode(_component_el_button, {
          type: "info",
          round: "",
          onClick: toIndustryList
        }, {
          default: _withCtx(() => [
            _createTextVNode(" 查看更多"),
            _createVNode(_component_el_icon, null, {
              default: _withCtx(() => [
                _createVNode(_component_ArrowRight)
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ])
    ]),
    _createElementVNode("div", _hoisted_58, [
      _hoisted_59,
      _createElementVNode("div", _hoisted_60, [
        _createElementVNode("div", _hoisted_61, [
          _createVNode(_component_el_carousel, {
            type: "card",
            height: "459px",
            arrow: "never",
            interval: 3000,
            autoplay: true
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(partyBuildingActivitesList.value, (item) => {
                return (_openBlock(), _createBlock(_component_el_carousel_item, {
                  key: item.id
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("img", {
                      class: "cover",
                      src: item.cover,
                      alt: ""
                    }, null, 8, _hoisted_62),
                    _createElementVNode("div", _hoisted_63, [
                      _createElementVNode("div", _hoisted_64, [
                        _createElementVNode("span", _hoisted_65, _toDisplayString(item.createdAt.day), 1),
                        _createElementVNode("span", _hoisted_66, "/" + _toDisplayString(item.createdAt.year) + "-" + _toDisplayString(item.createdAt.month), 1)
                      ]),
                      _createElementVNode("div", _hoisted_67, [
                        _createElementVNode("img", {
                          src: _imports_4,
                          alt: "",
                          onClick: ($event: any) => (handleListClick(item.id,'party'))
                        }, null, 8, _hoisted_68)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_69, _toDisplayString(item.title), 1)
                  ]),
                  _: 2
                }, 1024))
              }), 128))
            ]),
            _: 1
          })
        ])
      ]),
      _createElementVNode("div", _hoisted_70, [
        _createVNode(_component_el_button, {
          type: "info",
          round: "",
          onClick: toPartyList
        }, {
          default: _withCtx(() => [
            _createTextVNode(" 查看更多"),
            _createVNode(_component_el_icon, null, {
              default: _withCtx(() => [
                _createVNode(_component_ArrowRight)
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ])
    ]),
    _createElementVNode("div", _hoisted_71, [
      _hoisted_72,
      _createElementVNode("div", _hoisted_73, [
        _createElementVNode("div", _hoisted_74, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(digitalManagmentPlatformList.value, (item) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "item",
              key: item.id
            }, [
              _createElementVNode("img", {
                src: item.img,
                alt: "",
                class: "cover"
              }, null, 8, _hoisted_75),
              _createElementVNode("div", _hoisted_76, [
                _createElementVNode("div", _hoisted_77, _toDisplayString(item.title), 1),
                _createElementVNode("div", _hoisted_78, _toDisplayString(item.content), 1),
                _createElementVNode("div", {
                  class: "btn",
                  onClick: ($event: any) => (handleTitleClick(item))
                }, " 访问" + _toDisplayString(item.title), 9, _hoisted_79)
              ])
            ]))
          }), 128))
        ])
      ])
    ]),
    _hoisted_80
  ]))
}
}

})